export default function HeroSection() {
  const stats = [
    { value: '50+', label: '每日更新影片' },
    { value: '1080P', label: '高清画质保障' },
    { value: '全免费', label: '无广告畅快看' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20with%20deep%20charcoal%20background%2C%20warm%20crimson%20and%20golden%20light%20beams%20radiating%20from%20center%2C%20subtle%20film%20grain%20texture%20overlay%2C%20theatrical%20atmosphere%2C%20vintage%20movie%20projector%20light%20effect%2C%20elegant%20dramatic%20lighting%2C%20no%20text%2C%20no%20faces%2C%20artistic%20minimal%20design%2C%20high%20end%20editorial%20quality&width=1600&height=900&seq=hero-bg-cinema-01&orientation=landscape"
          alt="91电影视频 - 国产精品影视平台背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative w-full z-10 px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16 max-w-[1200px] mx-auto py-12 md:py-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/20 text-accent-400 border border-accent-500/30 mb-4 whitespace-nowrap">
              每日更新 · 高清流畅
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-3">
              91电影视频 - 国产精品影视高清免费在线观看
            </h1>

            <p className="text-lg md:text-xl text-accent-400 font-heading mb-5">
              重温经典，发现新作，一站式国产影视平台
            </p>

            <p className="text-sm md:text-base text-background-300/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              91电影视频专注国产精品影视内容，汇聚海量国产电影、热播电视剧、独家自制剧。
              所有影片支持高清画质在线播放，无需缓冲等待，更无需付费或注册。
              每日持续更新最新资源，覆盖动作、悬疑、喜剧、古装、都市等全类型题材，
              让每一位国产影视爱好者都能在这里找到心仪好片。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-background-400 mt-0.5">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium text-sm rounded-lg border border-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[380px] md:max-w-[440px] lg:max-w-[480px] shrink-0">
            <div className="relative rounded-xl overflow-hidden aspect-[3/4] bg-background-900/50">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20collage%20with%20warm%20golden%20and%20crimson%20tones%2C%20abstract%20film%20reel%20elements%2C%20soft%20light%20leaks%2C%20vintage%20theater%20curtain%20texture%2C%20artistic%20movie%20poster%20aesthetic%2C%20dramatic%20spotlight%20effect%2C%20no%20recognizable%20faces%2C%20no%20text%2C%20dreamy%20atmospheric%20glow%2C%20high%20end%20editorial%20photography&width=700&height=900&seq=hero-visual-cinema-01&orientation=portrait"
                alt="91电影视频 - 国产精品影视主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}